module.exports = __webpack_public_path__ + "static/media/PayRoll4.02b21550.png";